import { Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/content";
import { useLang } from "../lib/i18n";

export const Story = () => {
  const { c } = useLang();
  return (
  <section id="story" className="py-28 sm:py-40 px-6 bg-[#EEF2E3]" data-testid="story-section">
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight">
          {c.story.line1}
          <br />
          <span className="italic text-[#465220]">{c.story.line2}</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-16 md:gap-24 mt-20 items-start">
        <div className="space-y-16">
          {c.story.chapters.map((ch, i) => (
            <Reveal key={ch.n} delay={i * 0.05}>
              <div className="flex gap-6" data-testid={`story-chapter-${ch.n}`}>
                <span className="font-serif-display font-light text-5xl text-[#E15A70] leading-none">{ch.n}</span>
                <div>
                  <h3 className="font-serif-display text-2xl sm:text-3xl font-medium mb-3">{ch.title}</h3>
                  <p className="text-base leading-relaxed text-[#2C3552]/70 font-light">{ch.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-4 md:sticky md:top-28">
          <Reveal delay={0.1} className="col-span-2">
            <img src={IMAGES.story1} alt="Paulina and Louie" className="w-full h-72 sm:h-96 object-cover" loading="lazy" />
          </Reveal>
          <Reveal delay={0.2}>
            <img src={IMAGES.story2} alt="Paulina and Louie" className="w-full h-56 sm:h-72 object-cover" loading="lazy" />
          </Reveal>
          <Reveal delay={0.3}>
            <img src={IMAGES.story3} alt="Paulina and Louie" className="w-full h-56 sm:h-72 object-cover mt-8" loading="lazy" />
          </Reveal>
          <Reveal delay={0.35} className="col-span-2">
            <img src={IMAGES.story4} alt="Paulina and Louie with Bear" className="w-full h-64 sm:h-80 object-cover" loading="lazy" />
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};
